import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { ReasonRequest } from '@/main/models/request';


// Redux
import { saveReason } from './reasonActions';
import { GetReason } from './reasonTypes';

// Api's
import { reasonApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getReasonSaga(action: GetReason) {
  try {
    const response: AxiosResponse<Result<ReasonRequest[]>> = yield call(
      reasonApi.getDomain,
      action.payload.request
    );

    if (response.data.result) {
      yield put(saveReason(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveReason(null, true, resultError.messagesDataError));
    }
  }
}
